import { render, staticRenderFns } from "./filterBar.vue?vue&type=template&id=580eba5f&scoped=true&"
import script from "./filterBar.vue?vue&type=script&lang=js&"
export * from "./filterBar.vue?vue&type=script&lang=js&"
import style0 from "./filterBar.vue?vue&type=style&index=0&id=580eba5f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580eba5f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
